'use client'

// Карточка «Проверь моё сообщение» в репетиторе (tutor-qa.tsx): исходный
// текст, исправление с пояснением, два готовых варианта с озвучкой и
// кнопкой «Скопировать» — текст сразу уходит в WhatsApp.
import { useState } from 'react'
import type { MessageCheck } from '@/lib/deepseek'
import { TrText } from '@/components/tr-text'
import { SpeakButtons } from '@/components/speak-buttons'

function CopyButton({ text }: { text: string }) {
  const [done, setDone] = useState(false)
  return (
    <button
      type="button"
      className="tk-reveal-btn"
      style={{ padding: '6px 12px', fontSize: 14 }}
      onClick={async () => {
        try {
          await navigator.clipboard.writeText(text)
          setDone(true)
          setTimeout(() => setDone(false), 1500)
        } catch {}
      }}
    >
      {done ? 'Скопировано' : 'Скопировать'}
    </button>
  )
}

function Variant({ title, text }: { title: string; text: string }) {
  return (
    <div className="tk-vocab-card" style={{ alignItems: 'stretch', gap: 8, textAlign: 'left' }}>
      <div className="font-mono text-[12px] uppercase tracking-[0.08em] text-fg-muted">{title}</div>
      <div className="text-[17px] font-semibold leading-snug"><TrText text={text} /></div>
      <div className="flex flex-wrap items-center gap-2">
        <SpeakButtons text={text} />
        <CopyButton text={text} />
      </div>
    </div>
  )
}

export function MessageCheckCard({ original, check }: { original: string; check: MessageCheck }) {
  return (
    <div className="flex flex-col gap-3">
      <div className="tk-bubble tk-side-b" style={{ alignSelf: 'flex-end', maxWidth: '88%' }}>
        {original}
      </div>
      <div
        className="rounded-[12px] border px-3 py-2 text-[15px]"
        style={
          check.ok
            ? { borderColor: 'color-mix(in oklch, var(--tk-ice) 55%, transparent)', background: 'color-mix(in oklch, var(--tk-ice) 10%, transparent)' }
            : { borderColor: 'var(--tk-fire)', background: 'oklch(0.6 0.14 228 / 0.1)' }
        }
      >
        <div className="font-semibold" style={{ color: check.ok ? 'var(--tk-ice)' : 'var(--tk-gold)' }}>
          {check.ok ? 'Ошибок нет - можно отправлять' : 'Исправлено'}
        </div>
        {!check.ok && (
          <div className="mt-1 flex items-center justify-between gap-2">
            <div className="font-semibold"><TrText text={check.corrected} /></div>
            <SpeakButtons text={check.corrected} withSlow={false} />
          </div>
        )}
        {check.explanationRu && <div className="mt-1 opacity-90" style={{ color: 'var(--tk-translate)' }}>{check.explanationRu}</div>}
        {check.toneRu && <div className="mt-1 text-[14px] text-fg-muted">Как звучит: {check.toneRu}</div>}
      </div>
      <Variant title="Нейтрально" text={check.neutral} />
      <Variant title="Вежливо" text={check.polite} />
    </div>
  )
}
